var SHOP_THE_LOOK_SCROLL_BREAKPOINT_QUERY = typeof SHOP_THE_LOOK_SCROLL_BREAKPOINT_QUERY === "string"
    ? SHOP_THE_LOOK_SCROLL_BREAKPOINT_QUERY
    : "(max-width: 969px)";
function isDyDesktopViewport() {
    if (typeof window === "undefined") {
        return false;
    }

    if (typeof window.matchMedia === "function") {
        return window.matchMedia("(min-width: 970px)").matches;
    }
    return window.innerWidth >= 970;
}

var ADD_TO_CART_ICONS_HTML =
    '<span class="add-to-cart-icon add-to-cart-icon--progress" aria-hidden="true">' +
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--full-color icon-progress" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M6.77083 17.6769C5.75694 17.2394 4.87153 16.6422 4.11458 15.8853C3.35764 15.1283 2.76041 14.2429 2.32291 13.229C1.88541 12.2151 1.66666 11.1353 1.66666 9.98942C1.66666 8.84359 1.88541 7.7672 2.32291 6.76025C2.76041 5.75331 3.35764 4.87136 4.11458 4.11442C4.87153 3.35748 5.75694 2.76025 6.77083 2.32275C7.78472 1.88525 8.86111 1.6665 10 1.6665C10.2361 1.6665 10.434 1.74637 10.5937 1.90609C10.7535 2.06581 10.8333 2.26373 10.8333 2.49984C10.8333 2.73595 10.7535 2.93386 10.5937 3.09359C10.434 3.25331 10.2361 3.33317 10 3.33317C8.15277 3.33317 6.57986 3.98248 5.28125 5.28109C3.98264 6.5797 3.33333 8.15261 3.33333 9.99984C3.33333 11.8471 3.98264 13.42 5.28125 14.7186C6.57986 16.0172 8.15277 16.6665 10 16.6665C11.8472 16.6665 13.4201 16.0172 14.7187 14.7186C16.0174 13.42 16.6667 11.8471 16.6667 9.99984C16.6667 9.76373 16.7465 9.56581 16.9062 9.40609C17.066 9.24636 17.2639 9.1665 17.5 9.1665C17.7361 9.1665 17.934 9.24636 18.0937 9.40609C18.2535 9.56581 18.3333 9.76373 18.3333 9.99984C18.3333 11.1387 18.1146 12.2151 17.6771 13.229C17.2396 14.2429 16.6424 15.1283 15.8854 15.8853C15.1285 16.6422 14.2465 17.2394 13.2396 17.6769C12.2326 18.1144 11.1562 18.3332 10.0104 18.3332C8.86458 18.3332 7.78472 18.1144 6.77083 17.6769Z" fill="#E3E3E3"/>' +
    '</svg></span>' +
    '<span class="add-to-cart-icon add-to-cart-icon--check" aria-hidden="true">' +
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon-check" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M14.3333 1L5.16667 10.1667L1 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg></span>';

var QUICKSHOP_LOADING_STATE_HTML =
    '<div class="product-modal__loading-state" aria-hidden="true">' +
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--full-color icon-progress" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M6.77083 17.6769C5.75694 17.2394 4.87153 16.6422 4.11458 15.8853C3.35764 15.1283 2.76041 14.2429 2.32291 13.229C1.88541 12.2151 1.66666 11.1353 1.66666 9.98942C1.66666 8.84359 1.88541 7.7672 2.32291 6.76025C2.76041 5.75331 3.35764 4.87136 4.11458 4.11442C4.87153 3.35748 5.75694 2.76025 6.77083 2.32275C7.78472 1.88525 8.86111 1.6665 10 1.6665C10.2361 1.6665 10.434 1.74637 10.5937 1.90609C10.7535 2.06581 10.8333 2.26373 10.8333 2.49984C10.8333 2.73595 10.7535 2.93386 10.5937 3.09359C10.434 3.25331 10.2361 3.33317 10 3.33317C8.15277 3.33317 6.57986 3.98248 5.28125 5.28109C3.98264 6.5797 3.33333 8.15261 3.33333 9.99984C3.33333 11.8471 3.98264 13.42 5.28125 14.7186C6.57986 16.0172 8.15277 16.6665 10 16.6665C11.8472 16.6665 13.4201 16.0172 14.7187 14.7186C16.0174 13.42 16.6667 11.8471 16.6667 9.99984C16.6667 9.76373 16.7465 9.56581 16.9062 9.40609C17.066 9.24636 17.2639 9.1665 17.5 9.1665C17.7361 9.1665 17.934 9.24636 18.0937 9.40609C18.2535 9.56581 18.3333 9.76373 18.3333 9.99984C18.3333 11.1387 18.1146 12.2151 17.6771 13.229C17.2396 14.2429 16.6424 15.1283 15.8854 15.8853C15.1285 16.6422 14.2465 17.2394 13.2396 17.6769C12.2326 18.1144 11.1562 18.3332 10.0104 18.3332C8.86458 18.3332 7.78472 18.1144 6.77083 17.6769Z" fill="#E3E3E3"/>' +
    '</svg></div>';

function getProductModalAddToCartButtonHTML(label, extraClass) {
    var className = 'product-modal__add-to-cart btn';
    if (extraClass) {
        className += ' ' + extraClass;
    }
    return '<button class="' + className + '" data-add-to-cart type="button">' +
        ADD_TO_CART_ICONS_HTML +
        '<span data-add-to-cart-text>' + label + '</span></button>';
}

function setProductModalAddToCartLabel($buttons, label) {
    $buttons.each(function () {
        var $label = $(this).find('[data-add-to-cart-text]');
        if ($label.length) {
            $label.text(label);
        } else {
            $(this).text(label);
        }
    });
}

function getSoldOutLabel() {
    var isShopTheLookModal = $("#quickshop-modal").hasClass("quickshop-modal--shop-the-look-pop-up");
    if (isShopTheLookModal && window.theme && window.theme.showOosOnShopTheLook) {
        var customLabel = window.theme.shopTheLookOosLabel;
        if (customLabel && String(customLabel).trim()) {
            return String(customLabel).trim();
        }
    }
    return "Sold Out";
}

function isShopTheLookWaitlistEnabled() {
    return !!(window.theme && window.theme.showOosOnShopTheLook && window.theme.shopTheLookOosWaitlist);
}

function productHasPreorderTag(product) {
    return !!(product && Array.isArray(product.tags) &&
        product.tags.some(function (tag) {
            return String(tag).toLowerCase() === "pre-order";
        }));
}

function getShopTheLookWaitlistLabel(product) {
    if (productHasPreorderTag(product)) return "JOIN THE WAITLIST";
    var bis = document.getElementById("BIS_trigger");
    var inner = bis && bis.querySelector(".btn");
    var raw = bis
        ? String((inner && inner.textContent) || bis.textContent || "").trim()
        : "";
    return raw || "Email When Available";
}

function isShopTheLookPausedForWaitlist() {
    return $("#quickshop-modal").hasClass("shop-the-look-paused-for-waitlist");
}

function isBisSignupOpen() {
    var frames = document.querySelectorAll("#BIS_frame, iframe[id^=\"BIS_\"], iframe[name^=\"BIS_\"]");
    for (var i = 0; i < frames.length; i++) {
        var frame = frames[i];
        if (!frame || !frame.isConnected) continue;
        var style = window.getComputedStyle(frame);
        if (style.display === "none" || style.visibility === "hidden" || parseFloat(style.opacity || "1") === 0) {
            continue;
        }
        var rect = frame.getBoundingClientRect();
        if (rect.width > 1 && rect.height > 1) return true;
    }
    return false;
}

var stlWaitlistWatch = {
    watching: false,
    seenOpen: false,
    interval: null
};

function stopShopTheLookWaitlistWatch() {
    stlWaitlistWatch.watching = false;
    stlWaitlistWatch.seenOpen = false;
    if (stlWaitlistWatch.interval) {
        clearInterval(stlWaitlistWatch.interval);
        stlWaitlistWatch.interval = null;
    }
}

function pauseShopTheLookForWaitlist() {
    var $modal = $("#quickshop-modal");
    $modal.addClass("shop-the-look-paused-for-waitlist").removeClass("active");
    try {
        slate.a11y.removeTrapFocus({
            $container: $modal,
            namespace: "quickshop_focus"
        });
    } catch (e) {}
    unlockQuickshopBackgroundScroll();
}

function resumeShopTheLookAfterWaitlist() {
    var $modal = $("#quickshop-modal");
    if (!$modal.hasClass("shop-the-look-paused-for-waitlist")) return;
    stopShopTheLookWaitlistWatch();
    $modal.removeClass("shop-the-look-paused-for-waitlist").addClass("active");
    lockQuickshopBackgroundScroll();
    try {
        slate.a11y.trapFocus({
            $container: $modal,
            namespace: "quickshop_focus"
        });
    } catch (e) {}
}

function watchBisThenRestoreShopTheLook() {
    stopShopTheLookWaitlistWatch();
    stlWaitlistWatch.watching = true;
    var started = Date.now();
    stlWaitlistWatch.interval = setInterval(function () {
        if (!stlWaitlistWatch.watching) return;
        var open = isBisSignupOpen();
        if (open) {
            stlWaitlistWatch.seenOpen = true;
            return;
        }
        if (stlWaitlistWatch.seenOpen || Date.now() - started > 8000) {
            resumeShopTheLookAfterWaitlist();
        }
    }, 250);
}

function syncPdpVariantForWaitlist(product, variantId) {
    if (!product || !variantId || !window.productJSON) return;
    if (String(product.id) !== String(window.productJSON.id)) return;
    var idField = document.querySelector('.product-form [name="id"], form[action*="/cart/add"] [name="id"]');
    if (idField) {
        idField.value = String(variantId);
        if (window.jQuery) window.jQuery(idField).trigger("change");
    }
    var swatch = document.querySelector('.product-form [data-variant-id="' + variantId + '"]');
    if (swatch && swatch.getAttribute("for")) {
        var input = document.getElementById(swatch.getAttribute("for"));
        if (input) {
            input.checked = true;
            if (window.jQuery) window.jQuery(input).trigger("change");
        }
    }
}

function waitForBisTrigger(timeoutMs) {
    timeoutMs = typeof timeoutMs === "number" ? timeoutMs : 4000;
    return new Promise(function (resolve) {
        var existing = document.getElementById("BIS_trigger");
        if (existing) {
            resolve(existing);
            return;
        }
        var started = Date.now();
        var timer = setInterval(function () {
            var el = document.getElementById("BIS_trigger");
            if (el || Date.now() - started > timeoutMs) {
                clearInterval(timer);
                resolve(el || null);
            }
        }, 100);
    });
}

function openShopTheLookWaitlist(product, variantId) {
    if (!isShopTheLookWaitlistEnabled()) return false;
    pauseShopTheLookForWaitlist();
    watchBisThenRestoreShopTheLook();
    syncPdpVariantForWaitlist(product, variantId);
    waitForBisTrigger(4000).then(function (bisBtn) {
        if (!bisBtn) {
            resumeShopTheLookAfterWaitlist();
            return;
        }
        if (variantId) {
            bisBtn.setAttribute("data-variant-id", String(variantId));
        }
        if (product && product.id) {
            bisBtn.setAttribute("data-product-id", String(product.id));
        }
        bisBtn.click();
    });
    return true;
}

function syncProductModalAtcAvailability(available, product) {
    var $btn = $(".product-modal__add-to-cart");
    var isAvailable = available === true || available === "true";
    if (isAvailable) {
        $btn.removeAttr("data-stl-waitlist");
        $btn.prop("disabled", false);
        setProductModalAddToCartLabel($btn, "ADD TO BAG");
        return;
    }

    var useWaitlist = isShopTheLookWaitlistEnabled() &&
        $("#quickshop-modal").hasClass("quickshop-modal--shop-the-look-pop-up");

    if (useWaitlist) {
        $btn.attr("data-stl-waitlist", "true");
        $btn.prop("disabled", false);
        setProductModalAddToCartLabel($btn, getShopTheLookWaitlistLabel(product));
        return;
    }

    $btn.removeAttr("data-stl-waitlist");
    $btn.prop("disabled", true);
    setProductModalAddToCartLabel($btn, getSoldOutLabel());
}

function shouldUseQuickshopRedesignDesktop() {
    return isDyDesktopViewport();
}

function isQuickshopGiftCardProduct(product) {
    if (!product) {
        return false;
    }

    if (typeof product.gift_card === "boolean") {
        return product.gift_card;
    }

    return typeof product.type === "string" && product.type.toLowerCase() === "gift cards";
}

function trackQuickshopDyEvent(eventName, properties) {
    if (!window.DY || typeof window.DY.API !== "function") {
        return;
    }

    window.DY.API("event", {
        name: eventName,
        properties: properties || {}
    });
}

function isClpQuickshopPlusTrigger($trigger) {
    return $("body").hasClass("template-collection")
        && $trigger.hasClass("product-card__quickshop-plus")
        && !$trigger.closest("#CartDrawer, .ajaxcart").length;
}

function getDescriptionText(descriptionHtml) {
    if (!descriptionHtml || typeof descriptionHtml !== "string") {
        return "";
    }
    var temp = document.createElement("div");
    temp.innerHTML = descriptionHtml;
    var text = temp.textContent || temp.innerText || "";
    return text.replace(/\s+/g, " ").trim();
}

function getQuickshopMoneyFormatWithDecimals() {
    var moneyFormat = (window.theme && window.theme.moneyFormat) || "${{amount}}";

    return moneyFormat
        .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, "{{ amount_with_space_separator }}")
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, "{{ amount }}")
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, "{{ amount }}");
}

function formatQuickshopDisplayPrice(priceInCents) {
    if (priceInCents == null || priceInCents === "") {
        return "";
    }

    var cents = parseInt(priceInCents, 10);
    if (isNaN(cents)) {
        return "";
    }

    if (typeof window !== "undefined" && window.slate && slate.Currency && typeof slate.Currency.formatMoney === "function") {
        var originalFormat = (window.theme && window.theme.moneyFormat) || "${{amount}}";
        var formatted = slate.Currency.formatMoney(cents, getQuickshopMoneyFormatWithDecimals());
        // slate.Currency in this theme doesn't support `amount_with_comma_separator`, so normalize output when the
        // shop format requests comma-style separators.
        if (/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/i.test(originalFormat)) {
            formatted = formatted
                .replace(/,/g, "__TMP__")
                .replace(/\./g, ",")
                .replace(/__TMP__/g, ".");
        }
        return formatted;
    }

    return "$" + (cents / 100).toFixed(2);
}

function getStorefrontAccessToken() {
    if (typeof window === "undefined") {
        return "";
    }
    var config = window.zsConfig || {};
    return typeof config.storefrontAccessToken === "string" ? config.storefrontAccessToken : "";
}

var QUICKSHOP_CLOSE_ICON_SVG = '<svg class="product-modal__close-flat-icon" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4693 1.10555C12.3885 1.02495 12.2791 0.979677 12.165 0.979677C12.0509 0.979677 11.9415 1.02495 11.8607 1.10555L6.68533 6.28255L1.50997 1.10555C1.4699 1.06548 1.42233 1.0337 1.36998 1.01202C1.31763 0.990332 1.26152 0.979172 1.20486 0.979172C1.1482 0.979172 1.09209 0.990332 1.03974 1.01202C0.987389 1.0337 0.939822 1.06548 0.899755 1.10555C0.859688 1.14562 0.827905 1.19318 0.806221 1.24553C0.784537 1.29788 0.773376 1.35399 0.773376 1.41066C0.773376 1.46732 0.784537 1.52343 0.806221 1.57578C0.827905 1.62813 0.859688 1.67569 0.899755 1.71576L6.07676 6.8895L0.899755 12.0649C0.859795 12.1049 0.828118 12.1525 0.806533 12.2048C0.784948 12.2571 0.773877 12.3131 0.773953 12.3697C0.774029 12.4263 0.785249 12.4823 0.806974 12.5346C0.828699 12.5868 0.860504 12.6343 0.900571 12.6743C0.940637 12.7142 0.988183 12.7459 1.04049 12.7675C1.0928 12.7891 1.14885 12.8001 1.20544 12.8001C1.26202 12.8 1.31804 12.7888 1.37029 12.767C1.42255 12.7453 1.47001 12.7135 1.50997 12.6734L6.6837 7.49971L11.8591 12.6751C11.8989 12.7152 11.9464 12.747 11.9986 12.7687C12.0508 12.7904 12.1068 12.8016 12.1634 12.8016C12.2199 12.8016 12.2759 12.7904 12.3281 12.7687C12.3804 12.747 12.4278 12.7152 12.4677 12.6751C12.5483 12.5943 12.5935 12.4849 12.5935 12.3708C12.5935 12.2567 12.5483 12.1473 12.4677 12.0665L7.29391 6.89113L12.4693 1.71576C12.5094 1.67574 12.5413 1.62819 12.563 1.57584C12.5848 1.52348 12.596 1.46735 12.596 1.41066C12.596 1.35396 12.5848 1.29783 12.563 1.24547C12.5413 1.19312 12.5094 1.14557 12.4693 1.10555Z" fill="black"/></svg>';

function getProductModalReviewsHTML(productId, productUrl) {
    return '<a href="' + productUrl + '#okeWidget" class="product-modal__reviews review-wrapper">' +
        '<div data-oke-star-rating data-oke-reviews-product-id="shopify-' + productId + '"></div>' +
        '</a>';
}

function initProductModalReviews($scope) {
    var $root = $scope && $scope.length ? $scope : $('.product-modal__content');

    if (!$root.find('[data-oke-star-rating]').length) {
        return;
    }

    if (window.okeWidgetApi && typeof window.okeWidgetApi.initAllWidgets === 'function') {
        window.okeWidgetApi.initAllWidgets();
    }
}

function getProductModalWairImageUrl(results) {
    if (!results) {
        return "";
    }

    var variant = null;
    if (Array.isArray(results.variants) && results.variants.length) {
        variant = results.variants.find(function (item) {
            return item.available;
        }) || results.variants[0];
    }

    var src = (variant && variant.featured_image && variant.featured_image.src) || results.featured_image || "";
    if (!src) {
        return "";
    }

    src = src.replace(/^https?:/, "");
    if (!/_\d+x\./i.test(src) && /\.(jpe?g|png|webp)(\?|$)/i.test(src)) {
        src = src.replace(/(\.(jpe?g|png|webp))(\?|$)/i, "_x600$1$3");
    }

    return src;
}

function getProductModalWairHTML(results) {
    if (isQuickshopGiftCardProduct(results)) {
        return "";
    }

    var productName = (results.title || "").replace(/"/g, "&quot;");
    var imageUrl = getProductModalWairImageUrl(results);

    return '<div class="product-modal__wair predict-placement mt-md-2 mt-md-4 pt-md-0 mb-auto d-none d-md-flex flex-column align-self-center w-100"' +
        ' data-predict-product-key="' + (results.handle || "") + '"' +
        ' data-predict-product-name="' + productName + '"' +
        ' data-predict-product-img="' + imageUrl + '"></div>';
}

function waitForElmInScope($scope, selector, timeout) {
    timeout = timeout || 5000;
    var $root = $scope && $scope.length ? $scope : $("#quickshop-modal");

    return new Promise(function (resolve, reject) {
        var existingElement = $root.find(selector)[0];
        if (existingElement) {
            resolve(existingElement);
            return;
        }

        var observer = new MutationObserver(function () {
            var elm = $root.find(selector)[0];
            if (elm) {
                observer.disconnect();
                resolve(elm);
            }
        });

        observer.observe($root[0], {
            childList: true,
            subtree: true
        });

        setTimeout(function () {
            observer.disconnect();
            reject();
        }, timeout);
    });
}

function initProductModalWair($scope) {
    var $root = $scope && $scope.length ? $scope : $("#quickshop-modal");
    var $placement = $root.find(".product-modal__wair.predict-placement");

    if (!$placement.length) {
        return;
    }

    waitForElmInScope($placement, ".wair-launch-btn")
        .then(function () {
            $placement.find(".wair-launch-btn").attr("style", "font-size: 14px !important; max-width: fit-content;");
        })
        .catch(function () {});
}

function waitForImageElement(img) {
    return new Promise(function (resolve) {
        if (!img) {
            resolve();
            return;
        }
        if (img.complete && img.naturalWidth > 0) {
            resolve();
            return;
        }
        var finish = function () {
            img.removeEventListener("load", finish);
            img.removeEventListener("error", finish);
            resolve();
        };
        img.addEventListener("load", finish);
        img.addEventListener("error", finish);
    });
}

function waitForQuickshopModalReady($scope, timeoutMs) {
    timeoutMs = typeof timeoutMs === "number" ? timeoutMs : 1200;
    var $root = $scope && $scope.length ? $scope : $(".product-modal__content");
    var images = $root.find(".product-modal__content-image img").toArray();
    var imagesPromise = !images.length
        ? Promise.resolve()
        : Promise.all(images.map(waitForImageElement));
    var timeoutPromise = new Promise(function (resolve) {
        setTimeout(resolve, timeoutMs);
    });

    return Promise.race([imagesPromise, timeoutPromise]).then(function () {
        return new Promise(function (resolve) {
            var run = function () {
                var $slider = $root.find(".product-modal__content-image.slick-initialized");
                if ($slider.length) {
                    $slider.slick("setPosition");
                }
                resolve();
            };

            if (typeof window.requestAnimationFrame === "function") {
                window.requestAnimationFrame(function () {
                    window.requestAnimationFrame(run);
                });
            } else {
                run();
            }
        });
    });
}

function lockQuickshopBackgroundScroll() {
    $("body").css("overflow", "hidden");
    var drawer = document.querySelector("#CartDrawer");
    if (drawer) {
        drawer.setAttribute("data-quickshop-scroll-locked", "true");
    }
}

function unlockQuickshopBackgroundScroll() {
    var drawer = document.querySelector("#CartDrawer");
    if (drawer) {
        drawer.removeAttribute("data-quickshop-scroll-locked");
    }
    $("body").css("overflow", "");
}

function openQuickshopModal(clickedModalWindowBtn) {
    var $container = $(".product-modal__container");
    $container.removeClass("quickshop-modal--gift-card").addClass("active");
    if ($(clickedModalWindowBtn).attr("data-free-gift-modal")) {
        $container.addClass("free-gift-modal");
    } else {
        $container.removeClass("free-gift-modal");
    }
    lockQuickshopBackgroundScroll();
    try {
        slate.a11y.trapFocus({
            $container: $("#quickshop-modal"),
            namespace: "quickshop_focus"
        });
    } catch (e) {}
}

function getShippingExchangesText() {
    var $pdpText = $('#product-info .free-exchange-pdp .text-center').first();
    if ($pdpText.length && $pdpText.text().trim()) {
        return $pdpText.text().trim();
    }

    var modalText = $("#quickshop-modal").attr("data-shipping-exchanges-text");
    if (modalText) {
        return modalText;
    }

    return "Free Shipping on US Orders $50+ | Free Exchanges";
}

function getInitialVariantSku(results) {
    if (!results || !Array.isArray(results.variants) || !results.variants.length) {
        return "";
    }

    var variant = results.variants.find(function (item) {
        return item.available;
    }) || results.variants[0];

    return variant && variant.sku ? variant.sku : "";
}

function getProductModalAfterpayHTML(priceDollars, sku) {
    var amount = parseFloat(priceDollars);
    if (isNaN(amount)) {
        amount = 0;
    }

    return '<div class="afterpay-elem">' +
        '<square-placement' +
        ' data-mpid="8fff61fc-2110-4076-a58b-15793119c39f"' +
        ' data-placement-id="478f6978-da22-496c-a154-715ce66b477e"' +
        ' data-page-type="product"' +
        ' data-amount="' + amount + '"' +
        ' data-currency="USD"' +
        ' data-consumer-locale="en_US"' +
        ' data-item-skus="' + (sku || "") + '"' +
        ' data-is-eligible="true">' +
        '</square-placement>' +
        '</div>';
}

function getProductModalPostAtcHTML(results, priceDollars, variantSku) {
    if (isQuickshopGiftCardProduct(results)) {
        return "";
    }

    var message = getShippingExchangesText();
    var temp = document.createElement("div");
    temp.textContent = message == null ? "" : String(message);
    var safeMessage = temp.innerHTML;

    return '<div class="product-modal__post-atc">' +
        '<div class="free-exchange-pdp d-flex align-items-center">' +
        '<span class="d-flex flex-wrap justify-content-center">' +
        '<span class="text-center">' + safeMessage + '</span>' +
        '</span></div>' +
        getProductModalAfterpayHTML(priceDollars, variantSku) +
        '</div>';
}

function updateProductModalAfterpay($option) {
    if (!$option || !$option.length) {
        return;
    }

    var $placement = $("#quickshop-modal .afterpay-elem square-placement");
    if (!$placement.length) {
        return;
    }

    var priceCents = $option.attr("data-variant-price");
    var sku = $option.attr("data-variant-sku") || "";

    if (priceCents != null && priceCents !== "") {
        $placement.attr("data-amount", (parseInt(priceCents, 10) / 100).toFixed(2));
    }

    if (sku) {
        $placement.attr("data-item-skus", sku);
    }
}

function setQuickshopCloseIconVariant(useFlatIcon) {
    var $modal = $("#quickshop-modal");
    // Skip if this is a Shop the Look modal - it has its own close button styling
    if ($modal.hasClass("quickshop-modal--shop-the-look-pop-up")) {
        return;
    }
    var $closeButton = $modal.find(".product-modal__close");
    if (!$closeButton.length) {
        return;
    }

    if (useFlatIcon) {
        if (!$closeButton.find(".product-modal__close-flat-icon").length) {
            $closeButton.append(QUICKSHOP_CLOSE_ICON_SVG);
        }
        $closeButton.addClass("product-modal__close--flat");
    } else {
        $closeButton.removeClass("product-modal__close--flat");
        $closeButton.find(".product-modal__close-flat-icon").remove();
    }
}

function isShopTheLookMobileViewport() {
    if (typeof window === "undefined") {
        return false;
    }
    if (typeof window.matchMedia === "function") {
        return window.matchMedia(SHOP_THE_LOOK_SCROLL_BREAKPOINT_QUERY).matches;
    }
    return window.innerWidth <= 969;
}

function getCachedShopTheLookHeadline(handle) {
  if (!handle) return null;
  const cached = window.shopTheLookPopUpState && window.shopTheLookPopUpState.headlinesByHandle;
  const value = cached && cached[handle];
  return typeof value === "string" && value.trim() ? value : null;
}

async function fetchPdpHeadlineByHandle(handle, productId, signal) {
  const cachedHeadline = getCachedShopTheLookHeadline(handle);
  if (cachedHeadline) return cachedHeadline;

  const hasProductId = productId !== undefined && productId !== null && String(productId).length;
  const query = hasProductId
    ? `
    query getProductHeadline($id: ID!) {
      product: node(id: $id) {
        ... on Product {
          metafield(namespace: "custom", key: "pdp_headline") {
            value
          }
        }
      }
    }
  `
    : `
    query getProductByHandle($handle: String!) {
      product(handle: $handle) {
        metafield(namespace: "custom", key: "pdp_headline") {
          value
        }
      }
    }
  `;

  const variables = hasProductId
    ? { id: "gid://shopify/Product/" + productId }
    : { handle };

  try {
    const response = await fetch("/api/2024-07/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": getStorefrontAccessToken()
      },
      body: JSON.stringify({ query, variables }),
      signal: signal
    });

    const data = await response.json();
    if (!data?.data?.product) return null;
    return data?.data?.product?.metafield?.value || null;
  } catch (error) {
    if (error && error.name === "AbortError") {
      throw error;
    }
    console.error("Error fetching PDP headline:", error);
    return null;
  }
}

var quickshopHeadlineCache = {}; // { [handle]: { data, expiresAt } }

function fetchQuickshopHeadline(handle, signal) {
    var entry = quickshopHeadlineCache[handle];
    if (entry && entry.expiresAt > Date.now()) {
        return Promise.resolve(entry.data);
    }
    return fetchPdpHeadlineByHandle(handle, null, signal).then(function (value) {
        quickshopHeadlineCache[handle] = { data: value, expiresAt: Date.now() + 3 * 60 * 1000 };
        return value;
    }).catch(function (error) {
        if (error && error.name === "AbortError") {
            return null;
        }
        throw error;
    });
}

function updateAvailableSizesModal(clickedColorElement) {
    var colorSlug = null;
    if (clickedColorElement && clickedColorElement.length) {
        var colorBorder = clickedColorElement.closest('.product-modal__swatch-color-border');
        if (colorBorder && colorBorder.length) {
            colorSlug = colorBorder.attr('data-variant-value') || null;
        }
    }
    return refreshSizeAvailability(colorSlug);
}

function ensureActiveSizeSelection() {
    var $sizeContainer = $(".product-modal__swatch-container__size");
    if (!$sizeContainer.length) {
        return true;
    }

    var $sizeButtons = $sizeContainer.find('[js-modal-variant]');
    if (!$sizeButtons.length) {
        return true;
    }

    var $activeAvailable = $sizeButtons.filter('.active').not('.unavailable').first();
    if ($activeAvailable.length) {
        return true;
    }

    $sizeButtons.filter('.active').removeClass('active');
    var $firstAvailable = $sizeButtons.not('.unavailable').first();
    if ($firstAvailable.length) {
        $firstAvailable.addClass('active');
        return true;
    }

    return false;
}

function selectCarouselLookVariant(variantId) {
    if (!variantId) {
        return;
    }

    var $option = $('#product-modal__select-hidden option[data-variant-id="' + variantId + '"]');
    if (!$option.length) {
        return;
    }

    var colorSlug = $option.attr('data-color-slug') || '';
    if (colorSlug) {
        var $colorButtons = $('.product-modal__swatch-color-border');
        var $colorMatch = $colorButtons.filter('[data-variant-value="' + colorSlug + '"]');
        if ($colorMatch.length) {
            $colorButtons.removeClass('active');
            $colorMatch.addClass('active');
            var $names = $('.container__shop-the-look-pop-up .wrap__colors-names span');
            $names.removeClass('active');
            $names.filter('[attr-color-name="' + colorSlug + '"]').addClass('active');
        }
    }

    var sizeSlug = $option.attr('data-size-slug') || '';
    var $sizeButtons = $('.product-modal__swatch-container__size [js-modal-variant]');
    if (!sizeSlug || !$sizeButtons.length) {
        return;
    }

    var $sizeMatch = $sizeButtons.filter(function() {
        return normalizeQuickshopSlug($(this).attr('data-variant-value') || '') === sizeSlug;
    });
    if (!$sizeMatch.length) {
        return;
    }

    $sizeButtons.removeClass('active');
    $sizeMatch.addClass('active');
}

function refreshSizeAvailability(activeColorSlug) {
    var $sizeContainer = $(".product-modal__swatch-container__size");
    if (!$sizeContainer.length) {
        return true;
    }

    var $sizeButtons = $sizeContainer.find('[js-modal-variant]');
    if (!$sizeButtons.length) {
        return true;
    }

    $sizeButtons.each(function() {
        var $button = $(this);
        var sizeValue = $button.attr('data-variant-value') || $button.text() || '';
        var sizeSlug = normalizeQuickshopSlug(sizeValue);
        if (!sizeSlug) {
            $button.removeClass('unavailable').removeAttr('aria-disabled');
            return;
        }

        var selector = '#product-modal__select-hidden option[data-size-slug="' + sizeSlug + '"]';
        if (activeColorSlug) {
            selector += '[data-color-slug="' + activeColorSlug + '"]';
        }
        var $matchingOptions = $(selector);
        var hasAvailableVariant = $matchingOptions.toArray().some(function(option) {
            return option.getAttribute('data-available') === 'true';
        });

        if (hasAvailableVariant) {
            $button.removeClass('unavailable').removeAttr('aria-disabled');
        } else {
            $button.addClass('unavailable').attr('aria-disabled', 'true').removeClass('active');
        }
    });

    return ensureActiveSizeSelection();
}

function buildVariantKeyFromActiveSwatches(requiresSizeSelection) {
    if (requiresSizeSelection) {
        var hasSizeSelected = $(".product-modal__swatch-container__size .product-modal__swatch-other.active").length > 0;
        if (!hasSizeSelected) {
            return null;
        }
    }

    var segments = [];
    $(".active[js-modal-variant]").each(function(index, element) {
        var value = $(element).attr("data-variant-value");
        if (!value) {
            return;
        }
        var slug = normalizeQuickshopSlug(value);
        if (slug) {
            segments.push(slug);
        }
    });

    if (!segments.length) {
        return null;
    }

    return segments.join("-");
}

function normalizeQuickshopSlug(value) {
    if (!value || typeof value !== 'string') {
        return '';
    }
    var normalizedValue = value.trim();
    if (!normalizedValue) {
        return '';
    }

    if (window.spotDOM && typeof window.spotDOM.handleize === 'function') {
        return window.spotDOM.handleize(normalizedValue) || '';
    }

    if (typeof normalizedValue.normalize === 'function') {
        normalizedValue = normalizedValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return normalizedValue.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-+|-+$/g, '');
}

if (typeof window !== 'undefined' && typeof window.normalizeQuickshopSlug !== 'function') {
    window.normalizeQuickshopSlug = normalizeQuickshopSlug;
}

function hasQuickshopWaitlistTag(results) {
    var tags = (results.tags || []).map(function (t) {
        return String(t).toLowerCase().trim();
    });
    return tags.indexOf('pre-order') > -1 ||
        tags.indexOf('bis-manual-display') > -1 ||
        tags.indexOf('bis-display-manual') > -1;
}

function isColorSellableForQuickshop(results, colorValue, colorOptionPos) {
    if (!colorOptionPos) return true; // fail-open if option shape is unexpected
    var key = 'option' + colorOptionPos;
    var colorName = String(colorValue || '').toLowerCase();
    var variants = (results.variants || []).filter(function (v) {
        return String(v[key] || '').toLowerCase() === colorName;
    });
    if (!variants.length) return true; // fail-open
    var waitlistTagged = hasQuickshopWaitlistTag(results);
    return variants.some(function (v) {
        if (v.inventory_management == null) return true;
        // product.js omits inventory_quantity; only trust qty when the payload actually includes it.
        if (waitlistTagged && typeof v.inventory_quantity === 'number') {
            return v.inventory_quantity > 0;
        }
        return typeof v.available !== 'undefined' ? !!v.available : (v.inventory_quantity || 0) > 0;
    });
}

function isQuickshopColorHiddenByTag(results, colorSlug) {
    var tags = results.tags || [];
    for (var i = 0; i < tags.length; i++) {
        var tag = tags[i];
        if (!tag || String(tag).indexOf("hide-") === -1) continue;
        var prefix = String(tag).indexOf("hide-manual-") > -1 ? "hide-manual-" : "hide-";
        if (normalizeQuickshopSlug(String(tag).replace(prefix, "")) === colorSlug) {
            return true;
        }
    }
    return false;
}

function getRenderableQuickshopColorValues(results, colorValues, colorOptionPos) {
    var renderable = [];
    if (!Array.isArray(colorValues)) return renderable;
    var hideUnavailable = !!(window.theme && window.theme.hideExcludedColorsQuickshop);
    if (hideUnavailable && window.theme.showOosOnShopTheLook &&
        $("#quickshop-modal").hasClass("quickshop-modal--shop-the-look-pop-up")) {
        hideUnavailable = false;
    }
    for (var i = 0; i < colorValues.length; i++) {
        var value = colorValues[i];
        if (isQuickshopColorHiddenByTag(results, normalizeQuickshopSlug(value))) continue;
        if (hideUnavailable && !isColorSellableForQuickshop(results, value, colorOptionPos)) continue;
        renderable.push(value);
    }
    return renderable;
}

function getProductModalHTML__shopTheLookPopUp(results, price, description, isMobile, priceDisplay) {
    const shopTheLookState = window.shopTheLookPopUpState || {};
    const carouselLook = shopTheLookState.carouselLook;
    const variantMeta = carouselLook && Array.isArray(carouselLook.variantMeta)
        ? carouselLook.variantMeta
        : (Array.isArray(shopTheLookState.variantMeta) ? shopTheLookState.variantMeta : []);
    const activeVariantId = carouselLook ? carouselLook.activeVariantId : null;
    $("#quickshop-modal").removeClass("quickshop-modal--shop-the-look-pop-up");
    $("#quickshop-modal").removeClass("quickshop-modal--dy-new");
    $("#quickshop-modal").addClass("quickshop-modal--shop-the-look-pop-up");
    var descriptionText = getDescriptionText(description);
  // Desktop version
  const buttonsHTML = variantMeta
  .filter((varMeta) => varMeta.productHandle)
  .map(
    (varMeta) => `
      <button
        type="button"
        onclick="event.stopPropagation(); showModalWindow(this)"
        data-product-handle="${varMeta.productHandle}"
        data-button-type="shop_the_look_pop_up"
        data-color-slug="${varMeta.colorSlug || ''}"
        data-variant-id="${varMeta.id || ''}"
        class="shop_the_look_trigger_btn shop_the_look_trigger_btn--image ${(activeVariantId ? String(varMeta.id) === String(activeVariantId) : varMeta.productHandle === results.handle) ? 'active' : ''}">
        <img src="${(varMeta.image && varMeta.image.src) || ''}" alt="">
      </button>
    `
  )
  .join('');

  return `
    <div class="container__shop-the-look-pop-up">
        <button class="product-modal__close mob__close--btn__wrap">
            <svg class="mob__close--btn" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 13" height="14" width="14">
                <path fill="black" d="M12.4693 1.10555C12.3885 1.02495 12.2791 0.979677 12.165 0.979677C12.0509 0.979677 11.9415 1.02495 11.8607 1.10555L6.68533 6.28255L1.50997 1.10555C1.4699 1.06548 1.42233 1.0337 1.36998 1.01202C1.31763 0.990332 1.26152 0.979172 1.20486 0.979172C1.1482 0.979172 1.09209 0.990332 1.03974 1.01202C0.987389 1.0337 0.939822 1.06548 0.899755 1.10555C0.859688 1.14562 0.827905 1.19318 0.806221 1.24553C0.784537 1.29788 0.773376 1.35399 0.773376 1.41066C0.773376 1.46732 0.784537 1.52343 0.806221 1.57578C0.827905 1.62813 0.859688 1.67569 0.899755 1.71576L6.07676 6.8895L0.899755 12.0649C0.859795 12.1049 0.828118 12.1525 0.806533 12.2048C0.784948 12.2571 0.773877 12.3131 0.773953 12.3697C0.774029 12.4263 0.785249 12.4823 0.806974 12.5346C0.828699 12.5868 0.860504 12.6343 0.900571 12.6743C0.940637 12.7142 0.988183 12.7459 1.04049 12.7675C1.0928 12.7891 1.14885 12.8001 1.20544 12.8001C1.26202 12.8 1.31804 12.7888 1.37029 12.767C1.42255 12.7453 1.47001 12.7135 1.50997 12.6734L6.6837 7.49971L11.8591 12.6751C11.8989 12.7152 11.9464 12.747 11.9986 12.7687C12.0508 12.7904 12.1068 12.8016 12.1634 12.8016C12.2199 12.8016 12.2759 12.7904 12.3281 12.7687C12.3804 12.747 12.4278 12.7152 12.4677 12.6751C12.5483 12.5943 12.5935 12.4849 12.5935 12.3708C12.5935 12.2567 12.5483 12.1473 12.4677 12.0665L7.29391 6.89113L12.4693 1.71576C12.5094 1.67574 12.5413 1.62819 12.563 1.57584C12.5848 1.52348 12.596 1.46735 12.596 1.41066C12.596 1.35396 12.5848 1.29783 12.563 1.24547C12.5413 1.19312 12.5094 1.14557 12.4693 1.10555Z"/>
            </svg>
        </button>
        <div class="d-flex">
            <div class="d-flex flex-column wrap__title-variants">
                <div class="product-modal__shopTheLook--variants-title">
                    SHOP THE LOOK
                </div>
                <div class="product-modal__shopTheLook--variants d-flex flex-column">
                    ${buttonsHTML}
                </div>
            </div>
            <div class="flex-grow-1">
                <div class="d-flex wrap__product-image--info">
                    <div class="product-modal__content-image"></div>
                    <div class="product-modal__content-info">
                        <div class="d-flex">
                            <h1 class="product-modal__content-title text-left">${results.title}</h1>
                            <input type="hidden" class="ptitle" value="${results.title}">
                            <input type="hidden" class="pid" value="${results.id}">
                            <input type="hidden" class="ptype" value="${results.type}">
                            <input type="hidden" class="pbrand" value="${results.vendor}">
                            <input type="hidden" class="pprice" value="${price}">
                            <p class="product-modal__content-price text-left">${priceDisplay}</p>
                        </div>
                        ${descriptionText ? `<p class="product-modal__content-description text-left">${descriptionText}</p>` : ''}
                        <a class="product-modal__product-url" href="${results.url}">View Full Details</a>
                        <div class="product-modal__swatch-container"></div>
                        <div class="product-modal__input-atc">
                            <div class="product-modal__input-container">
                                <label class="product-modal__input-label" for="product-quantity">Quantity</label>
                                <button class="product-modal__input-adjust product-modal__input-adjust--minus">-</button>
                                <input class="product-modal__input" value="1" type="text" id="product-quantity">
                                <button class="product-modal__input-adjust product-modal__input-adjust--plus">+</button>
                            </div>
                            ${getProductModalAddToCartButtonHTML('ADD TO BAG', 'shop-the-look-add-to-cart')}
                        </div>
                        <select id="product-modal__select-hidden"></select>
                    </div>
                </div>
            </div>
        </div>
    </div>
  `;
}

function getProductModalHTML__dyNewQuickshop(results, price, descriptionText, priceDisplay) {
    $("#quickshop-modal").removeClass("quickshop-modal--shop-the-look-pop-up").addClass("quickshop-modal--dy-new");
    var descriptionHtml = descriptionText ? `<p class="product-modal__content-description text-left">${descriptionText}</p>` : '';
    return `
      <div class="container__quickshop-dy-new">
        <div class="wrap__product-image--info">
          <div class="product-modal__content-image"></div>
          <div class="product-modal__content-info">
            <div class="d-flex">
              <h1 class="product-modal__content-title text-left">${results.title}</h1>
              <input type="hidden" class="ptitle" value="${results.title}">
              <input type="hidden" class="pid" value="${results.id}">
              <input type="hidden" class="ptype" value="${results.type}">
              <input type="hidden" class="pbrand" value="${results.vendor}">
              <input type="hidden" class="pprice" value="${price}">
            </div>
            ${getProductModalReviewsHTML(results.id, results.url)}
            ${descriptionHtml}
            <a class="product-modal__product-url" href="${results.url}">View Full Details</a>
            <p class="product-modal__content-price text-left">${priceDisplay}</p>
            <div class="product-modal__swatch-container"></div>
            <div class="product-modal__input-atc">
              <div class="product-modal__input-container">
                <label class="product-modal__input-label" for="product-quantity">Quantity</label>
                <button class="product-modal__input-adjust product-modal__input-adjust--minus">-</button>
                <input class="product-modal__input" value="1" type="text" id="product-quantity">
                <button class="product-modal__input-adjust product-modal__input-adjust--plus">+</button>
              </div>
              ${getProductModalAddToCartButtonHTML('ADD TO BAG')}
            </div>
            ${getProductModalPostAtcHTML(results, price, getInitialVariantSku(results))}
            <select id="product-modal__select-hidden"></select>
          </div>
        </div>
      </div>
    `;
}

function getProductModalHTML(results, price, description, isMobile, priceDisplay) {
  var descriptionText = getDescriptionText(description);
  if (isMobile) {
    $("#quickshop-modal").removeClass("quickshop-modal--shop-the-look-pop-up quickshop-modal--dy-new");
    return `
      <div class="product-modal__header w-100 align-self-start d-flex align-items-center justify-content-end">
        <button onclick="document.getElementById('quickshop-modal').click()" class="product-modal__close">
            <svg class="close-icon-new" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">\
                                        <path d="M12.4693 1.10555C12.3885 1.02495 12.2791 0.979677 12.165 0.979677C12.0509 0.979677 11.9415 1.02495 11.8607 1.10555L6.68533 6.28255L1.50997 1.10555C1.4699 1.06548 1.42233 1.0337 1.36998 1.01202C1.31763 0.990332 1.26152 0.979172 1.20486 0.979172C1.1482 0.979172 1.09209 0.990332 1.03974 1.01202C0.987389 1.0337 0.939822 1.06548 0.899755 1.10555C0.859688 1.14562 0.827905 1.19318 0.806221 1.24553C0.784537 1.29788 0.773376 1.35399 0.773376 1.41066C0.773376 1.46732 0.784537 1.52343 0.806221 1.57578C0.827905 1.62813 0.859688 1.67569 0.899755 1.71576L6.07676 6.8895L0.899755 12.0649C0.859795 12.1049 0.828118 12.1525 0.806533 12.2048C0.784948 12.2571 0.773877 12.3131 0.773953 12.3697C0.774029 12.4263 0.785249 12.4823 0.806974 12.5346C0.828699 12.5868 0.860504 12.6343 0.900571 12.6743C0.940637 12.7142 0.988183 12.7459 1.04049 12.7675C1.0928 12.7891 1.14885 12.8001 1.20544 12.8001C1.26202 12.8 1.31804 12.7888 1.37029 12.767C1.42255 12.7453 1.47001 12.7135 1.50997 12.6734L6.6837 7.49971L11.8591 12.6751C11.8989 12.7152 11.9464 12.747 11.9986 12.7687C12.0508 12.7904 12.1068 12.8016 12.1634 12.8016C12.2199 12.8016 12.2759 12.7904 12.3281 12.7687C12.3804 12.747 12.4278 12.7152 12.4677 12.6751C12.5483 12.5943 12.5935 12.4849 12.5935 12.3708C12.5935 12.2567 12.5483 12.1473 12.4677 12.0665L7.29391 6.89113L12.4693 1.71576C12.5094 1.67574 12.5413 1.62819 12.563 1.57584C12.5848 1.52348 12.596 1.46735 12.596 1.41066C12.596 1.35396 12.5848 1.29783 12.563 1.24547C12.5413 1.19312 12.5094 1.14557 12.4693 1.10555Z" fill="black"/>\
            </svg>
        </button>
      </div>
      <div class="product-modal__content__wrap align-self-stretch">
        <div class="product-modal__content-image__wrapper active-slider-1">
          <div class="product-modal__content-image"></div>
        </div>
        <div class="product-modal__content-info">
          <div class="wrap-header-price d-flex justify-content-between">
            <h1 class="product-modal__content-title text-left">${results.title}</h1>
            <p class="product-modal__content-price">${priceDisplay}</p>
          </div>
          ${getProductModalReviewsHTML(results.id, results.url)}
          <a class="product-modal__product-url mt-0 border-bottom-0" href="${results.url}">View Full Details</a>
          <input type="hidden" class="ptitle" value="${results.title}">
          <input type="hidden" class="pid" value="${results.id}">
          <input type="hidden" class="ptype" value="${results.type}">
          <input type="hidden" class="pbrand" value="${results.vendor}">
          <input type="hidden" class="pprice" value="${price}">
          <div class="product-modal__swatch-container"></div>
          <select id="product-modal__select-hidden"></select>
        </div>
      </div>
      <div class="product-modal__footer align-self-end">
        <div class="product-modal__input-atc">
          <div class="product-modal__input-container">
            <label class="product-modal__input-label" for="product-quantity">Quantity</label>
            <button class="product-modal__input-adjust product-modal__input-adjust--minus" aria-label="Decrease item quantity by one">-</button>
            <input class="product-modal__input" value="1" type="text" id="product-quantity">
            <button class="product-modal__input-adjust product-modal__input-adjust--plus" aria-label="Increase item quantity by one">+</button>
          </div>
          ${getProductModalAddToCartButtonHTML('ADD TO BAG')}
        </div>
      </div>
    `;
  }
  if (shouldUseQuickshopRedesignDesktop()) {
    return getProductModalHTML__dyNewQuickshop(results, price, descriptionText, priceDisplay);
  }
  $("#quickshop-modal").removeClass("quickshop-modal--shop-the-look-pop-up quickshop-modal--dy-new");
  // Desktop version
  return `
    <div class="product-modal__content-image desktop-quick-shop-modal"></div>
    <div class="product-modal__content-info">
      <h1 class="product-modal__content-title">${results.title}</h1>
      <button type="button" data-product-handle="${results.handle}" data-button-type="shop_the_look_pop_up" class="shop_the_look_trigger_btn" onclick="showModalWindow($(this))">
        Shop the look
      </button>
      <input type="hidden" class="ptitle" value="${results.title}">
      <input type="hidden" class="pid" value="${results.id}">
      <input type="hidden" class="ptype" value="${results.type}">
      <input type="hidden" class="pbrand" value="${results.vendor}">
      <input type="hidden" class="pprice" value="${price}">
      <p class="product-modal__content-price">${priceDisplay}</p>
      <p class="product-modal__content-description">${descriptionText}</p>
      <div class="product-modal__swatch-container"></div>
      <div class="product-modal__input-atc">
        <div class="product-modal__input-container">
          <label class="product-modal__input-label" for="product-quantity">Quantity</label>
          <button class="product-modal__input-adjust product-modal__input-adjust--minus">-</button>
          <input class="product-modal__input" value="1" type="text" id="product-quantity">
          <button class="product-modal__input-adjust product-modal__input-adjust--plus">+</button>
        </div>
        ${getProductModalAddToCartButtonHTML('ADD TO BAG')}
      </div>
      <select id="product-modal__select-hidden"></select>
      <a class="product-modal__product-url" href="${results.url}">View Full Details</a>
    </div>
  `;
}

function setShopTheLookSlideWidths($slider) {
    if (!$slider || !$slider.length) return;
    // On small phones the slides are height-driven (see shop-the-look-pop-up-styles).
    // Clearing any leftover inline width lets the image determine slide width.
    if (window.matchMedia('(max-width: 767px)').matches) {
        $slider.find('.shop-the-look-slide').css('width', '');
        return;
    }
    var sliderWidth = $slider.width();
    if (!sliderWidth) return;
    var primaryWidth = Math.round(sliderWidth * 0.569);
    $slider.find('.shop-the-look-slide').css('width', primaryWidth + 'px');
}

function bindProductModalImageSliderWheel($slider) {
    if (!$slider || !$slider.length) return;

    var wheelThreshold = 160;
    var wheelCooldownMs = 650;

    $slider.each(function() {
        var $el = $(this);
        var wheelDelta = 0;
        var wheelLockedUntil = 0;

        $el.off('wheel.modalImageSliderWheel').on('wheel.modalImageSliderWheel', function(e) {
            if (!$el.hasClass('slick-initialized')) return;

            e.preventDefault();

            var now = Date.now();
            if (now < wheelLockedUntil) return;

            var deltaY = e.originalEvent.deltaY;
            if (!deltaY) return;

            wheelDelta += deltaY;

            if (wheelDelta <= -wheelThreshold) {
                wheelDelta = 0;
                wheelLockedUntil = now + wheelCooldownMs;
                $el.slick('slickPrev');
            } else if (wheelDelta >= wheelThreshold) {
                wheelDelta = 0;
                wheelLockedUntil = now + wheelCooldownMs;
                $el.slick('slickNext');
            }
        });
    });
}

function initVerticalModalImageSlider($slider, options) {
    var defaults = {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        dots: true,
        infinite: false,
        cssEase: 'ease-out',
        speed: 200,
        arrows: false
    };

    $slider.slick($.extend({}, defaults, options || {}));
}

function shopTheLookGalleryColorName($slider) {
    var colorName = $slider.closest(".container__shop-the-look-pop-up").find(".wrap__colors-names span.active").first().text();
    colorName = typeof colorName === "string" ? colorName.trim() : "";
    return colorName || null;
}

function shopTheLookMediaMatchesPdpGallery(media, colorName) {
    if (!media || media.media_type !== "image") return false;
    // Match the PDP's default (straight model) view, which hides curve model images.
    if (String(media.src || "").indexOf("_CURVE") !== -1) return false;
    var alt = typeof media.alt === "string" ? media.alt.trim() : "";
    if (alt.indexOf("Outfit Builder") !== -1) return false;
    if (!colorName) return true;
    // The PDP's straight model view shows only the active color's images (no "global").
    return alt === colorName;
}

function addSliderToModalProduct(results, variantStyleCode, variantStyleColor, productModalContentImage) {
    var isShopTheLookSlider = productModalContentImage.closest(".container__shop-the-look-pop-up").length > 0;
    var isDyNewQuickshopSlider = productModalContentImage.closest(".container__quickshop-dy-new").length > 0;
    var isShopTheLookMobile = isShopTheLookSlider && window.matchMedia("(max-width: 969px)").matches;
    var appendedSlides = 0;
    var usePdpGallery = isShopTheLookSlider && Array.isArray(results.media);
    var shouldLimitSlides = isShopTheLookSlider || isDyNewQuickshopSlider;
    var slideLimit = 6;
    var shopTheLookColorName = usePdpGallery ? shopTheLookGalleryColorName(productModalContentImage) : null;
    var productImages = usePdpGallery
        ? results.media.filter(function (media) {
            return shopTheLookMediaMatchesPdpGallery(media, shopTheLookColorName);
        })
        : (Array.isArray(results.images) ? results.images : []);

    for (var i = 0; i < productImages.length; i++) {
        var img = productImages[i];
        var imageSrc = null;

        if (typeof img === 'string') {
            imageSrc = img;
        } else if (img && typeof img === 'object' && img.src) {
            imageSrc = img.src;
        }

        if (!imageSrc) continue;

        if (usePdpGallery || (imageSrc.includes(variantStyleCode) && imageSrc.includes(variantStyleColor))) {
            var sizedImage = imageSrc.replace(/(\.(jpe?g|png|webp))$/i, '_900x$1');
            var slideImage = '<img src="' + sizedImage + '" alt=""' + (appendedSlides > 0 ? ' loading="lazy"' : '') + '>';
            var variantImage = isShopTheLookMobile
                ? '<div class="shop-the-look-slide">' + slideImage + '</div>'
                : slideImage;
            productModalContentImage.append(variantImage);
            appendedSlides++;

            if (shouldLimitSlides && appendedSlides >= slideLimit) {
                break;
            }
        }
    }

    if (appendedSlides === 0 && results.featured_image) {
        var fallbackSized = results.featured_image.replace(/(\.(jpe?g|png|webp))$/i, '_900x$1');
        var fallbackImage = '<img src="' + fallbackSized + '" alt="">';
        var fallbackSlide = isShopTheLookMobile
            ? '<div class="shop-the-look-slide">' + fallbackImage + '</div>'
            : fallbackImage;
        productModalContentImage.append(fallbackSlide);
    }

        if (isShopTheLookSlider) {
        if (isShopTheLookMobile) {
            productModalContentImage.off('.shopTheLookSlider');
            setShopTheLookSlideWidths(productModalContentImage);
            productModalContentImage.on('setPosition.shopTheLookSlider', function() {
                setShopTheLookSlideWidths(productModalContentImage);
            });
            // Slide widths follow the rendered image size (height-driven CSS),
            // so slick must recompute its offsets once each image loads.
            productModalContentImage.find('.shop-the-look-slide img').each(function () {
                if (this.complete) return;
                $(this).one('load.shopTheLookSlider', function () {
                    if (productModalContentImage.hasClass('slick-initialized')) {
                        productModalContentImage.slick('setPosition');
                    }
                });
            });
            productModalContentImage.addClass('shop-the-look-slider');
            productModalContentImage.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                infinite: false,
                variableWidth: true,
                arrows: false,
                cssEase: 'ease-out',
                speed: 200
            });
        } else {
            productModalContentImage.removeClass('shop-the-look-slider').off('.shopTheLookSlider');
            initVerticalModalImageSlider(productModalContentImage);
        }
    } else if (isDyNewQuickshopSlider) {
        productModalContentImage.removeClass('shop-the-look-slider').off('.shopTheLookSlider');
        initVerticalModalImageSlider(productModalContentImage);
    } else {
        productModalContentImage.slick({
            slidesToShow: 1,
            infinite: false,
            variableWidth: false,
            cssEase: 'ease-out',
            centerMode: true,
            useTransform: true,
            centerPadding: '17.5vw',
            speed: 150,
        });
    }

    if (productModalContentImage.hasClass('slick-initialized')) {
        bindProductModalImageSliderWheel(productModalContentImage);
    }

    productModalContentImage.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        const classPrefix = 'active-slider-';
        const $wrap = $('.product-modal__content-image__wrapper');

        $wrap.removeClass(function(index, className) {
            return (className.match(/(^|\s)active-slider-\d+/g) || []).join(' ');
        });

        $wrap.addClass(classPrefix + (nextSlide + 1));
    });
}

function addImageModalProduct(selectVariantImage, productModalContentImage) {
    var lazyloadImage = selectVariantImage.replace(".jpg", '_{width}x.jpg')
    var variantImage = '<img class="lazyload" src="' + selectVariantImage.replace('.jpg', '_300x.jpg') + '" data-src="' + lazyloadImage + '" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-sizes="auto">';
    productModalContentImage.append(
        variantImage
    )
}

var quickshopRequestToken = 0;
var currentQuickshopRequest = null;
var quickshopProductCache = {}; // { [handle]: { data, expiresAt } }

function fetchQuickshopProductJson(handle) {
    var entry = quickshopProductCache[handle];
    if (entry && entry.expiresAt > Date.now()) {
        return $.Deferred().resolve(entry.data).promise();
    }
    return $.ajax({ type: 'GET', url: '/products/' + handle + '.js', dataType: 'json' })
        .done(function (results) {
            quickshopProductCache[handle] = { data: results, expiresAt: Date.now() + 3 * 60 * 1000 };
        });
}

function abortCurrentQuickshopRequest() {
    if (!currentQuickshopRequest) return;
    if (currentQuickshopRequest.xhr && typeof currentQuickshopRequest.xhr.abort === "function") {
        currentQuickshopRequest.xhr.abort();
    }
    if (currentQuickshopRequest.controller && typeof currentQuickshopRequest.controller.abort === "function") {
        currentQuickshopRequest.controller.abort();
    }
    currentQuickshopRequest = null;
}

async function showModalWindow(clickedElm) {
    var clickedModalWindowBtn = $(clickedElm);
    var isClpQuickshopPlus = isClpQuickshopPlusTrigger(clickedModalWindowBtn);
    var quickshopModal = $("#quickshop-modal");
    if (isClpQuickshopPlus) {
        quickshopModal.attr("data-quickshop-source", "clp");
    } else {
        quickshopModal.removeAttr("data-quickshop-source");
    }
    // Canonical quickshop color contract is data-color-slug on the clicked trigger.
    // Keep legacy fallbacks for old integrations that still pass color name attributes.
    const triggerColorSlug = clickedModalWindowBtn.attr('data-color-slug')
        || clickedModalWindowBtn.closest('[data-color-slug]').attr('data-color-slug');
    let clickedColorSlug = (triggerColorSlug && triggerColorSlug.length) ? normalizeQuickshopSlug(String(triggerColorSlug)) : null;

    let legacyColorName = clickedModalWindowBtn.attr('data-color-name')
        || clickedModalWindowBtn.closest('[data-color-name]').attr('data-color-name')
        || clickedModalWindowBtn.closest('[attr-color]').attr("attr-color")
        || clickedModalWindowBtn.closest('.product-card').find('.product-card__swatch-container .product-card__swatch-border.active').attr('data-swatch-name');
    if (!clickedColorSlug && legacyColorName && typeof legacyColorName === 'string') {
        legacyColorName = legacyColorName.trim();
        clickedColorSlug = normalizeQuickshopSlug(legacyColorName);
    }
    var $productHandle = $(clickedModalWindowBtn).attr("data-product-handle");
    var $buttonType = $(clickedModalWindowBtn).attr("data-button-type");
    var requestedVariantId = clickedModalWindowBtn.attr("data-variant-id") || null;
    var shopLookState = window.shopTheLookPopUpState || {};
    var openedFromCarousel = clickedModalWindowBtn.is("[data-influencer-shop-look]");
    var insideQuickshop = clickedModalWindowBtn.closest("#quickshop-modal").length > 0;
    if (!openedFromCarousel && !(insideQuickshop && shopLookState.carouselLook)) {
        shopLookState.carouselLook = null;
    } else if (shopLookState.carouselLook && requestedVariantId) {
        shopLookState.carouselLook.activeVariantId = requestedVariantId;
    }
    var productId = $(clickedModalWindowBtn).attr("attr-pr-id");
    if (!$productHandle) {
        clickedModalWindowBtn.removeClass("quickshop-loading").removeAttr("aria-disabled").css("pointer-events", "");
        $("#quickshop-modal").removeAttr("data-quickshop-source");
        return;
    }
    if (isClpQuickshopPlus) {
        var $productCard = clickedModalWindowBtn.closest(".product-card");
        trackQuickshopDyEvent("CLP Quickshop", {
            pageUrl: window.location.href,
            product_handle: $productHandle,
            product_name: $productCard.find(".product-card__title").text().trim()
        });
    }
    if ($(clickedModalWindowBtn).attr("data-free-gift-modal")) {
        $(".product-modal__container").addClass("free-gift-modal");
    } else {
        $(".product-modal__container").removeClass("free-gift-modal");
    }
    var isShopTheLookPopupTrigger = ($buttonType && $buttonType == "shop_the_look_pop_up");
    var shouldDeferQuickshopOpen = shouldUseQuickshopRedesignDesktop() && !isShopTheLookPopupTrigger;
    if (!isShopTheLookPopupTrigger) {
        // Set the redesign/slide-in class before .active is added, so the open
        // animation is correct from the first frame instead of jumping once the
        // real content (which used to set this class) finishes loading.
        $("#quickshop-modal").removeClass("quickshop-modal--shop-the-look-pop-up")
            .toggleClass("quickshop-modal--dy-new", shouldDeferQuickshopOpen);
    }
    openQuickshopModal(clickedModalWindowBtn);
    if (!isShopTheLookPopupTrigger) {
        $(".product-modal__content").empty().append(QUICKSHOP_LOADING_STATE_HTML);
    }

    quickshopRequestToken++;
    var thisQuickshopRequestToken = quickshopRequestToken;
    abortCurrentQuickshopRequest();
    var quickshopHeadlineController = (typeof AbortController === "function") ? new AbortController() : null;
    var quickshopHeadlinePromise = fetchQuickshopHeadline($productHandle, quickshopHeadlineController && quickshopHeadlineController.signal);
    var quickshopProductRequest = fetchQuickshopProductJson($productHandle);
    currentQuickshopRequest = { xhr: quickshopProductRequest, controller: quickshopHeadlineController };

    quickshopProductRequest
        .done(async function (results) {
            if (thisQuickshopRequestToken !== quickshopRequestToken) return;
            $("#quickshop-modal").toggleClass("quickshop-modal--gift-card", isQuickshopGiftCardProduct(results));
            var isShopTheLookPopup = ($buttonType && $buttonType == "shop_the_look_pop_up");
            let prodModContent = $(".product-modal__content");

                    var rawDescription = typeof results.description === 'string' ? results.description : '';
                    var $description_full = rawDescription;
                    let headline = '';
                    try {
                        headline = await quickshopHeadlinePromise;
                    } catch (error) {
                        console.warn('Failed to fetch PDP headline:', error);
                        headline = '';
                    }
                    if (thisQuickshopRequestToken !== quickshopRequestToken) return;
                    const headlineText = getDescriptionText(headline);
                    const hasHeadline = headlineText !== '';
                    const descriptionFallback = getDescriptionText(rawDescription.split("<!-- details -->")[0]);
                    const $description = hasHeadline ? headlineText : descriptionFallback;
                    const $shopTheLookDescription = hasHeadline ? headlineText : '';
                    var $priceCents = results.price;
                    var $price = $priceCents / 100;
                    var $priceDisplay = formatQuickshopDisplayPrice($priceCents);
                    var isMobile = window.newModalAjaxWindow && window.matchMedia('(max-width: 767px)').matches; 
                    var colorOptionPosition = null;
                    var sizeOptionPosition = null;
                    if (Array.isArray(results.options)) {
                        results.options.forEach(function(option, index) {
                            if (!option || !option.name) return;
                            var normalizedName = option.name.toLowerCase();
                            if (normalizedName === 'color') {
                                colorOptionPosition = index + 1;
                            }
                            if (normalizedName === 'size') {
                                sizeOptionPosition = index + 1;
                            }
                        });
                    }
                    var hasSizeOption = sizeOptionPosition !== null;
                    if (isShopTheLookPopup) {
                        prodModContent.empty().append(getProductModalHTML__shopTheLookPopUp(results, $price, $shopTheLookDescription, isMobile, $priceDisplay));
                        if (!$("#quickshop-modal").hasClass('quickshop-modal--shop-the-look-pop-up')) { 
                            prodModContent.removeClass("d-inline-flex").addClass("d-inline-flex"); 
                        } else {
                            prodModContent.removeClass("d-inline-flex");
                        } 
                        prodModContent.closest(".product-modal").removeClass("text-center").addClass("text-center");
                        // Note: Shop the Look has its own close button - don't modify it
                    } else {
                        var useDyNewQuickshopStyles = !isMobile && shouldUseQuickshopRedesignDesktop();
                        prodModContent.empty().append(getProductModalHTML(results, $price, $description, isMobile, $priceDisplay));
                        setQuickshopCloseIconVariant(useDyNewQuickshopStyles);
                    }

                    // Printing Out Swatches
                    $.each(results.options, function (i, option) {
                        var handleizedOption = normalizeQuickshopSlug(option.name)
                        // Color Swatch
                        if (option.name === 'Color') {
                            var renderableColorValues = getRenderableQuickshopColorValues(results, option.values, colorOptionPosition);
                            var firstColorName = renderableColorValues.length ? normalizeQuickshopSlug(renderableColorValues[0]) : null;
                            var activeColor = firstColorName;
                            if (clickedColorSlug) {
                                for (var renderableColorIndex = 0; renderableColorIndex < renderableColorValues.length; renderableColorIndex++) {
                                    if (normalizeQuickshopSlug(renderableColorValues[renderableColorIndex]) === clickedColorSlug) {
                                        activeColor = clickedColorSlug;
                                        break;
                                    }
                                }
                            }
                            // Append Swatch Title (Color)
                            let colors_names_html = '<div class="wrap__colors-names">';
                            renderableColorValues.forEach(function(element) {
                                if (activeColor && normalizeQuickshopSlug(element) === activeColor) {
                                    colors_names_html += '<span class="active" attr-color-name="'+normalizeQuickshopSlug(element)+'">' + element + '</span>';
                                } else {
                                    colors_names_html += '<span attr-color-name="'+normalizeQuickshopSlug(element)+'">' + element + '</span>';
                                }
                            });
                            colors_names_html += '</div>';
                            const colorWrapperClasses = ["product-modal__wrap__row-color-swatchers", "d-flex"];
                            if (isShopTheLookPopup) {
                                colorWrapperClasses.push("shop-the-look-option", "shop-the-look-option--color");
                            }
                            const colorHeaderClasses = ["product-modal__swatch-header__wraper"];
                            if (isShopTheLookPopup) {
                                colorHeaderClasses.push("shop-the-look-option__heading");
                            }
                            const colorSwatchGroupStart = isShopTheLookPopup ? '<div class="shop-the-look-option__swatch-group">' : '';
                            const colorSwatchGroupEnd = isShopTheLookPopup ? '</div>' : '';

                            $(".product-modal__swatch-container").append(
                                `<div class="${colorWrapperClasses.join(' ')}">
                                    <div class="${colorHeaderClasses.join(' ')}">
                                        <p class="product-modal__swatch-header product-modal__swatch-header--color product-modal__swatch-header--color__new">Color:</p>
                                        ${colors_names_html}
                                    </div>
                                    ${colorSwatchGroupStart}
                                        <div class="product-modal__swatch-container-each--color product-modal__swatch-container-each" role="group" aria-labelledby="product-modal-swatch-header-${handleizedOption}"></div>
                                    ${colorSwatchGroupEnd}
                                </div>`
                            )
                            // Append Swatch Items (Eg. red)
                            
                            $.each(renderableColorValues, function (i, value) {
                                var firstLoop = ""
                                var handleizedValue = normalizeQuickshopSlug(value);
                                var colorValue = value
                                firstLoop = handleizedValue === activeColor ? "active" : "";

                                if (results.tags.length > 0) {
                                    var relevantCard = $('div#' +  results.id );
                                    var relevantCardColorSwatch =  relevantCard.find('.product-card__text-container').find('.product-card__swatch-container').find('button[data-swatch-name="'+colorValue+'"]');
                                    var modalWindowColorSwatch;
                                    let colorName = colorValue.toLocaleLowerCase().replaceAll(" ", "-");
                                    let sku = results.variants[0].sku.split("-")[0];
                                    let skuClean = sku.toUpperCase().endsWith("S") ? sku.slice(0, -1) : sku;
                                    let skuCleanLowerCase = skuClean.toLowerCase();
                                    let customSwatchUrl = `https://cdn.shopify.com/s/files/1/0076/7075/9477/files/color-${colorName}-${skuCleanLowerCase}.png`;
                                    if (relevantCardColorSwatch.length > 0) {
                                        var backgroundImageCss = relevantCardColorSwatch.find('.product-card__swatch').css('background-image');
                                        if (backgroundImageCss) {
                                            modalWindowColorSwatch = backgroundImageCss.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
                                        } else {
                                            // Fallback or default image if css property is not found
                                            modalWindowColorSwatch = 'https://cdn.shopify.com/s/files/1/0076/7075/9477/files/color-' + handleizedValue + '.png';
                                        }
                                    } else {
                                        modalWindowColorSwatch = 'https://cdn.shopify.com/s/files/1/0076/7075/9477/files/color-' + handleizedValue + '.png';
                                    }
                                    let bg = `url(${customSwatchUrl}), url(${modalWindowColorSwatch})`;
                                    $(".product-modal__swatch-container-each--color").append(
                                        '<div js-modal-variant data-variant-value=' + handleizedValue + ' class="product-modal__swatch-color-border ' + firstLoop + '">' +
                                        '<div class="modal_window-color-label modal_window-color-label__bottom">'+value+'</div>' +
                                        '<button class="product-modal__swatch-color" style="background-color:' + value + '; background-image: '+bg+'" aria-label="' + value + '"></button>' +
                                        '</div>'
                                    );
                                    if (window.newModalAjaxWindow && (window.matchMedia('(max-width: 767px)').matches || $(".product-modal__content-image").closest(".container__shop-the-look-pop-up"))) {
                                        $('.product-modal__container__new #product-modal-swatch-header-color span').text($(".product-modal__container__new .product-modal__swatch-color-border.active").attr('data-variant-value'));
                                    }
                                } else {
                                    $(".product-modal__swatch-container-each--color").append(
                                        '<div js-modal-variant data-variant-value=' + handleizedValue + ' class="product-modal__swatch-color-border ' + firstLoop + '">' +
                                        '<button class="product-modal__swatch-color" style="background-color:' + value + '; background-image: url(https://cdn.shopify.com/s/files/1/0076/7075/9477/files/color-' + handleizedValue + '.png" aria-label="' + value + '"></button>' +
                                        '</div>'
                                    )
                                }
                            });
                            if ($(".product-modal__swatch-container-each--color").children().length === 0) {
                                $(".product-modal__wrap__row-color-swatchers").remove();
                            }
                        }
                        // Swatch that are not Color
                        else {
                            const optionSlug = option.name.toLowerCase();
                            const otherWrapperClasses = [
                                "product-modal__swatch-container-each--other",
                                `product-modal__swatch-container__${optionSlug}`,
                                "product-modal__swatch-container-each"
                            ];
                            if (isShopTheLookPopup) {
                                otherWrapperClasses.push("shop-the-look-option", `shop-the-look-option--${handleizedOption}`);
                            }
                            const otherHeader = isShopTheLookPopup
                                ? `<div class="shop-the-look-option__heading">
                                      <p class="product-modal__swatch-header product-modal__swatch-header--${option.name}__new product-modal__swatch-header--other">${option.name}:</p>
                                   </div>`
                                : "";
                            const otherGroupStart = isShopTheLookPopup ? '<div class="shop-the-look-option__swatch-group">' : "";
                            const otherGroupEnd = isShopTheLookPopup ? '</div>' : "";
                            const otherButtonsWrapper = isShopTheLookPopup
                                ? `<div class="wrap__${optionSlug} d-flex"></div>`
                                : `<div class="wrap__${optionSlug} d-flex"><p class="product-modal__swatch-header product-modal__swatch-header--${option.name}__new product-modal__swatch-header--other">${option.name}:</p></div>`;

                            $(".product-modal__swatch-container").append(
                                `<div class="${otherWrapperClasses.join(' ')}" role="group" aria-labelledby="product-modal-swatch-header-${handleizedOption}">
                                    ${otherHeader}
                                    ${otherGroupStart}
                                        ${otherButtonsWrapper}
                                    ${otherGroupEnd}
                                </div>`
                            )
                            $.each(option.values, function (i, value) {
                                var firstLoop = "";
                                if (i == 0 && optionSlug !== 'size') {
                                    firstLoop = "active";
                                }
                                var currentHandleizedValue = normalizeQuickshopSlug(value)
                                var currentValue = value;
                                if (currentHandleizedValue == 'x-small') {
                                    currentValue = 'XS'
                                } else if (currentHandleizedValue == 'small') {
                                    currentValue = 'S'
                                } else if (currentHandleizedValue == 'medium') {
                                    currentValue = 'M'
                                } else if (currentHandleizedValue == 'large') {
                                    currentValue = 'L'
                                } else if (currentHandleizedValue == 'x-large') {
                                    currentValue = 'XL'
                                } else if (currentHandleizedValue == 'xsmall-small') {
                                    currentValue = 'XS/S'
                                } else if (currentHandleizedValue == 'small-medium') {
                                    currentValue = 'S/M'
                                } else if (currentHandleizedValue == 'medium-large') {
                                    currentValue = 'M/L'
                                } else if (currentHandleizedValue == 'large-xlarge') {
                                    currentValue = 'L/XL'
                                } else if (currentHandleizedValue == 'one-size') {
                                    currentValue = 'OS'
                                } else if (currentHandleizedValue.indexOf("size-") != -1) {
                                    currentValue = currentHandleizedValue.replace("size-", "")
                                } else if (currentHandleizedValue.indexOf("-months") != -1) {
                                    currentValue = currentHandleizedValue.replace("-months", "")
                                }
                                $(`.wrap__${option.name.toLowerCase()}`).append(
                                    '<button js-modal-variant data-variant-value="' + value + '" class="product-modal__swatch-other ' + firstLoop + '" aria-label="' + value + '">' + currentValue + '</button>'
                                )
                            })
                        }
                    })

                    if (!isMobile && !isShopTheLookPopup && shouldUseQuickshopRedesignDesktop()) {
                        var $sizeContainer = $(".product-modal__swatch-container__size");
                        if ($sizeContainer.length) {
                            $sizeContainer.append(getProductModalWairHTML(results));
                        }
                    }

                    // Printing out Variant ID into a hidden select
                    $.each(results.variants, function (i, variant) {
                        let $handleizedVariantTitle = normalizeQuickshopSlug(variant.title || '');
                        var variantImageSrc = (variant.featured_image && variant.featured_image.src) ? variant.featured_image.src : '';
                        var variantColorValue = colorOptionPosition ? variant["option" + colorOptionPosition] : '';
                        var variantSizeValue = sizeOptionPosition ? variant["option" + sizeOptionPosition] : '';
                        var variantColorSlug = normalizeQuickshopSlug(variantColorValue || '');
                        var variantSizeSlug = normalizeQuickshopSlug(variantSizeValue || '');
                        var optionHtml = `<option data-available="${variant.available}" data-variant-image="${variantImageSrc}" data-variant-price="${variant.price}" data-variant-title="${$handleizedVariantTitle}" data-variant-id="${variant.id}" data-color-slug="${variantColorSlug}" data-size-slug="${variantSizeSlug}">${$handleizedVariantTitle}</option>`;
                        $("#product-modal__select-hidden").append(optionHtml);
                    })
                    var initialColorSlug = $(".product-modal__swatch-color-border.active").attr("data-variant-value") || null;
                    refreshSizeAvailability(initialColorSlug);
                    if (window.shopTheLookPopUpState && window.shopTheLookPopUpState.carouselLook && requestedVariantId) {
                        selectCarouselLookVariant(requestedVariantId);
                    }
                    // Printing Out images
                    var $selection = buildVariantKeyFromActiveSwatches(hasSizeOption);
                
                    var $selectionOption = $selection ? $("#product-modal__select-hidden option[data-variant-title='" + $selection + "']") : $();
                    var $selectVariantImage = $selectionOption.attr("data-variant-image");
                    var variantStyleCode = null;
                    var variantStyleColor = null;
                    if (
                        typeof $selectVariantImage === "string" &&
                        $selectVariantImage.includes("/files/")
                    ) {
                        var splitFiles = $selectVariantImage.split("/files/");
                        if (splitFiles.length > 2) {
                            var splitUnderscore = splitFiles[2].split("_");
                            if (splitUnderscore.length > 1) {
                                variantStyleCode = splitUnderscore[0];
                                variantStyleColor = splitUnderscore[1];
                            }
                        }
                    }
                    var productModalContentImage =  $(".product-modal__content-image");
                    var isShopTheLookPopup = ($buttonType && $buttonType == "shop_the_look_pop_up");
                    if (typeof $selectVariantImage !== "undefined" && $selectVariantImage !== null) {
                        var isDyNewQuickshopContext = productModalContentImage.closest(".container__quickshop-dy-new").length > 0;
                        if (
                            window.newModalAjaxWindow &&
                            (window.matchMedia('(max-width: 767px)').matches || productModalContentImage.closest(".container__shop-the-look-pop-up").length > 0 || isDyNewQuickshopContext) &&
                            !productModalContentImage.hasClass("desktop-quick-shop-modal")
                        ) {
                            addSliderToModalProduct(results, variantStyleCode, variantStyleColor, productModalContentImage);
                        } else {
                            addImageModalProduct($selectVariantImage, productModalContentImage);
                        }
                    } else {
                        productModalContentImage.append(
                            '<img src="' + results.featured_image + '"/>'
                        )
                    }
                    
                    // Detect if on load if product is available
                    var $selectVariantAvailable = $selectionOption.attr("data-available");
                    if (!$selectionOption.length || $selectVariantAvailable === "false") {
                        syncProductModalAtcAvailability(false, results);
                    } else {
                        syncProductModalAtcAvailability(true, results);
                    }
                    updateProductModalAfterpay($selectionOption);




                    // Clicking on Modal Swatch
                    $("[js-modal-variant]").click(function () {
                        var clickedElm = $(this);
                        var isShopTheLookContext = clickedElm.closest(".container__shop-the-look-pop-up").length > 0;
                        var shopTheLookScrollContainer = null;
                        var previousScrollTop = null;
                        var shouldRestoreScroll = false;

                        if (isShopTheLookContext) {
                            shopTheLookScrollContainer = document.querySelector("#quickshop-modal.quickshop-modal--shop-the-look-pop-up .container__shop-the-look-pop-up");
                            shouldRestoreScroll = !!shopTheLookScrollContainer && isShopTheLookMobileViewport();
                            if (shouldRestoreScroll) {
                                previousScrollTop = shopTheLookScrollContainer.scrollTop;
                            }
                        }

                        if ($(clickedElm).hasClass("unavailable")) {
                            return;
                        }

                        var isColorSwatch = $(clickedElm).hasClass("product-modal__swatch-color-border");
                        if (isColorSwatch) {
                            var hasSizesAvailable = updateAvailableSizesModal($(clickedElm));
                            if (hasSizeOption && hasSizesAvailable === false) {
                                syncProductModalAtcAvailability(false, results);
                            }
                        }

                        $(clickedElm).closest(".product-modal__swatch-container-each").find(".active").removeClass("active");
                        $(clickedElm).addClass("active");

                        var colorCode = $(".product-modal__swatch-container-each--color").find(".product-modal__swatch-color-border.active").attr("data-variant-value");
                        if (colorCode) {
                            var $colorNameWrapper = clickedElm.closest(".product-modal__content").find(".wrap__colors-names");
                            if (!$colorNameWrapper.length) {
                                $colorNameWrapper = $(".container__shop-the-look-pop-up .wrap__colors-names");
                            }
                            if ($colorNameWrapper.length) {
                                $colorNameWrapper.find("span").removeClass("active");
                                $colorNameWrapper.find('span[attr-color-name="'+colorCode+'"]').addClass("active");
                            }
                        }

                        var formatColorSize = buildVariantKeyFromActiveSwatches(hasSizeOption);
                        if (!formatColorSize) {
                            syncProductModalAtcAvailability(false, results);
                            return;
                        }

                        var $nextVariantOption = $("#product-modal__select-hidden option[data-variant-title='" + formatColorSize + "']");
                        if (!$nextVariantOption.length) {
                            syncProductModalAtcAvailability(false, results);
                            return;
                        }

                        var $selectVariantPrice = $nextVariantOption.attr("data-variant-price");
                        if ($selectVariantPrice) {
                            $(".product-modal__content-price").html(formatQuickshopDisplayPrice($selectVariantPrice));
                        }
                        updateProductModalAfterpay($nextVariantOption);

                        var $selectVariantAvailable = $nextVariantOption.attr("data-available");
                        if ($selectVariantAvailable === "false") {
                            syncProductModalAtcAvailability(false, results);
                        } else {
                            syncProductModalAtcAvailability(true, results);
                        }
                        var $contentImage = $(".product-modal__content-image");
                        var isInDyNewQuickshop = $contentImage.closest(".container__quickshop-dy-new").length > 0;
                        var isInShopTheLook = $contentImage.closest(".container__shop-the-look-pop-up").length > 0;
                        if (window.newModalAjaxWindow && (window.matchMedia('(max-width: 767px)').matches || isInShopTheLook || isInDyNewQuickshop) && !$contentImage.hasClass("desktop-quick-shop-modal")) {
                            // Properly destroy slick instance and clear content for new variant
                            if ($contentImage.hasClass("slick-initialized")) {
                                $contentImage.slick("unslick");
                            }
                            $contentImage.empty();
                        } else if (isInShopTheLook || isInDyNewQuickshop) {
                            // Also handle ShopTheLook popup and DY new quickshop desktop slider
                            if ($contentImage.hasClass("slick-initialized")) {
                                $contentImage.slick("unslick");
                            }
                            $contentImage.empty();
                        } else {
                            $contentImage.empty();
                        }

                        var selectVariantImage = $nextVariantOption.attr("data-variant-image");
                        try {
                            // Reset variantStyleCode and variantStyleColor for each variant change
                            var variantStyleCode = '';
                            var variantStyleColor = '';
                            if (
                                typeof selectVariantImage === "string" &&
                                selectVariantImage.includes("/files/")
                            ) {
                                var filesSplit = selectVariantImage.split("/files/");
                                if (filesSplit.length > 2 && filesSplit[2].includes("_")) {
                                    var underscoreSplit = filesSplit[2].split("_");
                                    variantStyleCode = underscoreSplit[0];
                                    variantStyleColor = underscoreSplit[1];
                                } else {
                                    // fallback if structure is not as expected
                                    throw new Error("Unexpected image URL structure");
                                }
                            } else {
                                // fallback if not a string or missing '/files/'
                                throw new Error("Image URL missing '/files/' or not a string");
                            }
                        } catch (e) {
                            selectVariantImage = $("#quickshop-modal.product-modal__container__new .slick-current").attr("src");
                        }
                        
                        
                        if (window.newModalAjaxWindow && (window.matchMedia('(max-width: 767px)').matches || isInShopTheLook || isInDyNewQuickshop) && !$contentImage.hasClass("desktop-quick-shop-modal")) {
                            
                            if (window.newModalAjaxWindow && (window.matchMedia('(max-width: 767px)').matches || isInShopTheLook || isInDyNewQuickshop)) {
                                $('.product-modal__container__new #product-modal-swatch-header-color span').text($(".product-modal__container__new .product-modal__swatch-color-border.active").attr('data-variant-value'));
                                if($(clickedElm)[0].className.includes("swatch-color-border")) {
                                    $("#product-modal-swatch-header-color span").text($(clickedElm).attr('data-variant-value').replaceAll("-", " "));
                                }

                                addSliderToModalProduct(results, variantStyleCode, variantStyleColor, $contentImage);
                                $contentImage.slick('slickGoTo', 0);
                            } else {
                                var lazyloadImage = selectVariantImage.replace(".jpg", '_{width}x.jpg');
                                var variantImage = '<img class="lazyload" src="' + selectVariantImage.replace('.jpg', '_300x.jpg') + '" data-src="' + lazyloadImage + '" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-sizes="auto"></img>';

                                $contentImage.append(
                                    variantImage
                                )
                            }
                           
                        } else {
                            $contentImage.append(
                                '<img src="' + results.featured_image + '">'
                            )
                        }

                        if (shouldRestoreScroll && shopTheLookScrollContainer !== null && previousScrollTop !== null) {
                            var restoreScroll = function () {
                                shopTheLookScrollContainer.scrollTop = previousScrollTop;
                            };
                            if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
                                window.requestAnimationFrame(restoreScroll);
                            } else {
                                setTimeout(restoreScroll, 0);
                            }
                        }
                    })
                    // Clicking on Add to Cart Button
                    $(".product-modal__add-to-cart").click(function (event) {
                        var $modalWindow = $(this).closest("#quickshop-modal");
                        var isClpQuickshopModal = $modalWindow.attr("data-quickshop-source") === "clp";
                        var formatColorSize = buildVariantKeyFromActiveSwatches(hasSizeOption);
                        if ($(this).attr("data-stl-waitlist") === "true") {
                            event.preventDefault();
                            var waitlistVariantId = null;
                            if (formatColorSize) {
                                waitlistVariantId = $("#product-modal__select-hidden option[data-variant-title='" + formatColorSize + "']").attr("data-variant-id");
                            }
                            if (!waitlistVariantId) {
                                var colorSlug = $(".product-modal__swatch-color-border.active").attr("data-variant-value");
                                var $oosOptions = $("#product-modal__select-hidden option[data-available='false']");
                                if (colorSlug) {
                                    waitlistVariantId = $oosOptions.filter('[data-color-slug="' + colorSlug + '"]').first().attr("data-variant-id");
                                }
                                if (!waitlistVariantId) {
                                    waitlistVariantId = $oosOptions.first().attr("data-variant-id");
                                }
                            }
                            openShopTheLookWaitlist(results, waitlistVariantId);
                            return;
                        }
                        if (!formatColorSize) {
                            syncProductModalAtcAvailability(false, results);
                            return;
                        }

                        var $selectedVariantOption = $("#product-modal__select-hidden option[data-variant-title='" + formatColorSize + "']");
                        if (!$selectedVariantOption.length) {
                            syncProductModalAtcAvailability(false, results);
                            return;
                        }

                        var $selectVariantId = $selectedVariantOption.attr("data-variant-id");
                        if (!$selectVariantId) {
                            syncProductModalAtcAvailability(false, results);
                            return;
                        }
                        if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.setAddToCartIconState === 'function') {
                            ajaxCart.setAddToCartIconState('adding');
                        }
                        var $inputQuantity = $(".product-modal__input").val();
                        var productForm = $('.product-modal__content-info');
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'ee_addToCart',
                            name: productForm.find('.ptitle').val(),
                            id: productForm.find('.pid').val(),
                            price: productForm.find('.pprice').val(),
                            brand: productForm.find('.pbrand').val(),
                            product_type: productForm.find('.ptype').val(),
                            quantity: $inputQuantity,
                            variant: $selectVariantId,
                            g_product_id: "shopify_US_" + productForm.find('.pid').val() + "_" + $selectVariantId
                        });
                        $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            dataType: 'json',
                            data: 'quantity=' + $inputQuantity + '&id=' + $selectVariantId + '&sections=cart,cart-count&sections_url=' + encodeURIComponent(window.location.pathname),
                            id: $selectVariantId,
                            quantity: $inputQuantity,
                            error: function (XMLHttpRequest, textStatus) {
                                console.log("error");
                                if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.setAddToCartIconState === 'function') {
                                    ajaxCart.setAddToCartIconState('idle');
                                }
                                if (window.ShopifyAPI && typeof ShopifyAPI.notifyItemError === 'function') {
                                    ShopifyAPI.notifyItemError(XMLHttpRequest, textStatus);
                                }
                            },
                            success: function (response) {
                                if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.setAddToCartIconState === 'function') {
                                    ajaxCart.setAddToCartIconState('added');
                                }
                                if (!isShopTheLookPopup) {
                                    try {
                                        slate.a11y.removeTrapFocus({
                                            $container: $('#quickshop-modal'),
                                            namespace: 'quickshop_focus'
                                        });
                                    } catch (e) {}
                                    $(".product-modal__container").removeClass("active quickshop-modal--gift-card");
                                    $(".product-modal__content").empty();
                                    $("#quickshop-modal").removeAttr("data-quickshop-source");
                                    unlockQuickshopBackgroundScroll();
                                }
                                if (window.ShopifyAPI && typeof ShopifyAPI.notifyItemAdded === 'function') {
                                    ShopifyAPI.notifyItemAdded(response, productForm.get(0));
                                }
                                try {
                                    if (isClpQuickshopModal) {
                                        trackQuickshopDyEvent("CLP Quickshop ATC", {
                                            product_id: response.product_id,
                                            sku: response.sku,
                                            quantity: response.quantity,
                                            price_usd: (response.price / 100).toFixed(2)
                                        });
                                    }
                                    // Desktop Cart Quickshop ATC event (skip for Shop The Look)
                                    if (!isShopTheLookPopup && !window.matchMedia('(max-width: 767px)').matches && window.DY && typeof DY.API === "function") {
                                        DY.API("event", {
                                            name: "Desktop Cart Quickshop ATC",
                                            properties: {
                                                product_id: response.product_id,
                                                sku: response.sku,
                                                quantity: response.quantity,
                                                price_usd: (response.price / 100).toFixed(2)
                                            }
                                        });
                                    }
                                    // Shop The Look ATC event
                                    if (isShopTheLookPopup && window.DY && typeof DY.API === "function") {
                                        DY.API("event", {
                                            name: "Shop The Look - ATC",
                                            properties: {
                                                pageUrl: window.location.href
                                            }
                                        });
                                    }
                                    OrderSummaryUpdater.prototype.refresh();
                                } catch (e) {
                                    console.log(e);
                                }
                                if (
                                  theme &&
                                  response &&
                                  theme.CartConfirmationPopup &&
                                  (
                                    (document.body && document.body.classList.contains('atc-confirmation-variation--1')) ||
                                    (document.getElementById('MainContent') && document.getElementById('MainContent').classList.contains('atc-confirmation-variation--1'))
                                  ) &&
                                  !window.matchMedia('(max-width: 767px)').matches
                                ) {
                                    response.quantityAdded = parseInt($inputQuantity, 10) || 1;
                                    theme.CartConfirmationPopup.setLastAddedItem(response);
                                }
                                var cartDrawer = document.querySelector('cart-drawer');
                                var drawer = document.querySelector('#CartDrawer');
                                var showConfirmation = theme &&
                                  theme.CartConfirmationPopup &&
                                  (
                                    (document.body && document.body.classList.contains('atc-confirmation-variation--1')) ||
                                    (document.getElementById('MainContent') && document.getElementById('MainContent').classList.contains('atc-confirmation-variation--1'))
                                  ) &&
                                  !window.matchMedia('(max-width: 767px)').matches;

                                if (cartDrawer && response.sections) {
                                  cartDrawer.renderContents(response);
                                } else if (cartDrawer) {
                                  cartDrawer.refreshSections();
                                }

                                if (showConfirmation && theme.CartConfirmationPopup.getLastAddedItem()) {
                                  fetch('/cart.js', { headers: { Accept: 'application/json' } })
                                    .then(function(r) { return r.json(); })
                                    .then(function(cart) {
                                      theme.CartConfirmationPopup.show(theme.CartConfirmationPopup.getLastAddedItem(), cart);
                                    });
                                } else if (drawer) {
                                  drawer.open();
                                }
                                try {
                                    klavioAddedToCartViaAjax(response);
                                } catch (e) {}
                                handleQuickshopAddToCartMobile(response, $modalWindow);
                            }
                        })
                    })

                    // Minus Button adjust quantity
                    $(".product-modal__input-adjust--minus").click(function () {
                        var $inputVal = parseInt($(".product-modal__input").val());
                        if (($inputVal - 1) > 0) {
                            $(".product-modal__input").val($inputVal - 1)
                        }
                    })
                    // Plus Button adjust quantity
                    $(".product-modal__input-adjust--plus").click(function () {
                        var $inputVal = parseInt($(".product-modal__input").val());
                        $(".product-modal__input").val($inputVal + 1)
                    })

                    if (!isShopTheLookPopup && (shouldUseQuickshopRedesignDesktop() || isMobile)) {
                        initProductModalReviews(prodModContent);
                    }
                    if (shouldUseQuickshopRedesignDesktop() && !isMobile && !isShopTheLookPopup) {
                        initProductModalWair(prodModContent);
                    }
                    if ($('.product-modal__container').hasClass('free-gift-modal')) {
                        // Code to execute when the element has the class
                        // Append '.product-description-text_modal' before first '.product-description-text' element
                        $('.free-gift-modal').find('.product-description-text').first().before('<div class="product-description-text product-description-text_modal"></div>');
                        $('.free-gift-modal').find('.product-description-text').addClass('d-none');
                        $('.free-gift-modal').find('.product-description-text_modal').removeClass('d-none').addClass('d-block');
                        
                        // Append '<p>Select a size and color for your free gift</p>' into '.product-description-text_modal'
                        $('.free-gift-modal').find('.product-description-text_modal').append('<p>Select a size and color for your free gift</p>');

                        // Parse 'fit' from description
                        var $fit = $description_full.match(/<p><strong><span style="text-decoration: underline;" data-mce-style="text-decoration: underline;">FIT<\/span><\/strong><\/p>\n<p>(.*?)<\/p>/);
                        if ($fit) {
                            $('.free-gift-modal').find('.product-modal__swatch-container-each--other').append('<div class="d-block w-100"><p>' + $fit[1] + '</p></div>');
                        }
                    }

                    updateColorNamePosition();

                    if (isShopTheLookPopup || shouldDeferQuickshopOpen) {
                        try {
                            await waitForQuickshopModalReady(prodModContent);
                        } catch (e) {
                            console.warn("Quickshop modal preload wait failed:", e);
                        }
                    }
                })
                .fail(function () {
                    if (thisQuickshopRequestToken !== quickshopRequestToken) return;
                    try {
                        slate.a11y.removeTrapFocus({
                            $container: $("#quickshop-modal"),
                            namespace: "quickshop_focus"
                        });
                    } catch (e) {}
                    unlockQuickshopBackgroundScroll();
                    $(".product-modal__container").removeClass("active quickshop-modal--gift-card free-gift-modal");
                    $(".product-modal__content").empty();
                    $("#quickshop-modal").removeAttr("data-quickshop-source");
                })
                .always(function () {
                    clickedModalWindowBtn.removeClass("quickshop-loading").removeAttr("aria-disabled").css("pointer-events", "");
                });
}

var QUICKSHOP_TRIGGER_SELECTOR = ".product-card__quick-view-trigger, .product-card__quick-view-trigger_only, .product-card__quick-view-style, [data-quickshop-trigger], .shop_the_look_trigger_btn";

function getQuickshopDelegateRoots() {
    return [$(document.body), $("#CartDrawer")];
}

function initQuickshopClickHandlers() {
    getQuickshopDelegateRoots().forEach(function($root) {
        if (!$root.length) return;
        $root
            .off("click.quickshop", QUICKSHOP_TRIGGER_SELECTOR)
            .on("click.quickshop", QUICKSHOP_TRIGGER_SELECTOR, function (event) {
                event.preventDefault();
                showModalWindow($(this));
            });
    });
}

function initQuickshopAfterCartUpdate(options) {
    initQuickshopClickHandlers();
    if (options && options.skipGwp) return;
    if (typeof addGwpToCartDrawer === "function") {
        addGwpToCartDrawer();
    }
}

function bindQuickshopCartUpdateListener() {
    if (bindQuickshopCartUpdateListener.initialized) return;
    bindQuickshopCartUpdateListener.initialized = true;

    function scheduleQuickshopRefresh() {
        requestAnimationFrame(function () {
            initQuickshopAfterCartUpdate();
            setTimeout(function () {
                initQuickshopAfterCartUpdate({ skipGwp: true });
            }, 500);
        });
    }

    if (window.CartUtils && window.CartUtils.subscriptions && window.PUB_SUB_EVENTS) {
        CartUtils.subscriptions.subscribe(window.PUB_SUB_EVENTS.cartUpdate, scheduleQuickshopRefresh);
    }

    document.addEventListener("CartDrawer:open", scheduleQuickshopRefresh);
}

window.initQuickshopAfterCartUpdate = initQuickshopAfterCartUpdate;

function cardModalWindow() {
    initQuickshopClickHandlers();

    if (window.__quickshopInitialized) { return; }
    window.__quickshopInitialized = true;

    if ($("body").hasClass("template-collection") ||
        $("body").hasClass("template-product") ||
        $("body").hasClass("template-search") ||
        $("body").hasClass("template-index") ||
        $("body").hasClass("template-cart") ||
        $("body").hasClass("template-page") ||
        $("body").is("#z-supply-spring-2021-collection") ||
        $("body").is("#checkout-page") ||
        $("body").hasClass("page_layout--essentials-2022") ||
        $("body").hasClass("template-404") ||
        $("body").is("#marketplace-by-z-supply")) {
        function closeQuickshopModal() {
            if (isShopTheLookPausedForWaitlist()) return;
            quickshopRequestToken++;
            abortCurrentQuickshopRequest();

            // Remove focus on quickshop modal
            slate.a11y.removeTrapFocus({
                $container: $('#quickshop-modal'),
                namespace: 'quickshop_focus'
            });

            $(".product-modal__container").removeClass("active quickshop-modal--gift-card");
            $(".product-modal__content").empty();
            $("#quickshop-modal").removeAttr("data-quickshop-source");
            unlockQuickshopBackgroundScroll();
        }

        // Click close to close modal (delegate for dynamically injected buttons)
        $("body").off('click.quickshopClose').on('click.quickshopClose', ".product-modal__close", function (event) {
            event.preventDefault();
            event.stopPropagation();
            closeQuickshopModal();
        });

        // Click anywhere but the modal and trigger close modal
        $(".product-modal__container").click(function () {
            closeQuickshopModal();
        });
        $(".product-modal__content").click(function (e) {
            if ($(e.target).closest(".product-modal__close").length) {
                return; // allow close buttons inside content to bubble up
            }
            e.stopPropagation();
        });

        // Escape Close Modal
        $(document).on('keyup', function (evt) {
            if (evt.keyCode == 27) {
                closeQuickshopModal();
            }
        });

        // No modal on mobile
        // enquire.register(theme.config.mediaQueries.smallDown, {
        //     match: function () {
        //         $(".product-modal__close").trigger("click");
        //     },
        //     unmatch: function () {}
        // })
    }
    // Image change for Home Page
    $(".homepage-featured-products__content .color__border, #wrap_slider_spring_2021_page .color__border").click(function () {
        var $currentVal = $(this).attr("data-val");
        var $swatch = $(this).closest(".swatch")
        var $link = $swatch.closest(".product-card").find(".product-card__image-container").children(".product-card__link");
        $link.find(".product-card__image.active").removeClass("active");
        $link.children(".product-card__image").each(function () {
            if ($(this).attr("data-title").indexOf($currentVal) > -1) {
                $(this).addClass("active");
                return false
            }
        })
    });
}



function updateColorNamePosition() {
    waitForElm(".product-modal__container__new .product-modal__wrap__row-color-swatchers .product-modal__swatch-container-each--color").then((elm) => {
        var prodModalNew = $(".product-modal__container.product-modal__container__new");
        if (prodModalNew.hasClass("active")) {
            var topColorTitle = Math.floor( $('.product-modal__swatch-container-each--color').width() / 41 );
            if (topColorTitle < $(".product-modal__swatch-color-border").length) {
                $(".product-modal__swatch-color-border").each(function(index) {
                    if (topColorTitle > index) {
                        if (!$(".product-modal__container.product-modal__container__new").hasClass("quickshop-modal--shop-the-look-pop-up")) {
                            $(this).find('.modal_window-color-label').removeClass('modal_window-color-label__bottom');
                        }

                        var isDyNewQuickshop = $("#quickshop-modal").hasClass("quickshop-modal--dy-new");
                        if (!isDyNewQuickshop && !$('.product-modal__container__new .product-modal__swatch-container').hasClass("pt-3")) {
                            $('.product-modal__container__new .product-modal__swatch-container').addClass("pt-3")
                        }
                    }
                });
            } 
        }
    });
}

function handleQuickshopAddToCartMobile(response, mainElm) {
  if (window.matchMedia('(max-width: 767px)').matches) {
    var nameOfEvent = $(mainElm).hasClass("product-modal__container__new")
      ? "New"
      : "Old";

    DY.API("event", {
      name: `Event - Quickshop Add to Cart (Mobile - ${nameOfEvent})`,
      properties: {
        product_id: response.product_id,
        sku: response.sku,
        quantity: response.quantity,
        price_usd: (response.price / 100).toFixed(2)
      }
    });
  }
}


window.addEventListener("load", function () {
    cardModalWindow();
    bindQuickshopCartUpdateListener();
});
